import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {
    CssBaseline, CircularProgress, Container, Grid, Button, Tabs, Tab, Box,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, IconButton, Tooltip,
    FormControlLabel, Checkbox
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import Footer from '../../components/footer';
import ConfirmActionDialog from '../../components/confirm-action-dialog';
import { injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SyncIcon from '@material-ui/icons/Sync';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import Switch from '@material-ui/core/Switch';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminProductService from '../../services/admin-product.service';
import * as adminApplicationService from '../../services/admin-application.service';
import * as adminBillingService from '../../services/admin-billing.service';
import Api from "../../services/api";
import PlanPeriodicityDialog from '../../components/plan-periodicity-dialog';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

class AdminProductDetail extends Component {
    constructor(props) {
        super(props);

        const product = (props.location && props.location.state && props.location.state.product) || {};

        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            product: product,
            tabValue: 0,
            gateways: [],
            planPeriodicities: [],
            // Ensure gateway product dialog
            syncDialogOpen: false,
            syncGatewayId: null,
            syncGatewayName: '',
            // Plan Periodicity detail dialog
            ppDetailDialogOpen: false,
            ppDetail: null,
            ppGateways: [],
            // Ensure gateway price dialog
            priceDialogOpen: false,
            priceGatewayId: null,
            priceGatewayName: '',
            pricePlanPeriodicityId: null,
            priceValue: '',
            // Features
            features: [],
            featureDialogOpen: false,
            featureDialogMode: 'create',
            featureDialogId: null,
            featureDialogFeatureId: '',
            featureDialogName: '',
            featureDialogDescription: '',
            featureNextId: 1,
            deleteFeatureDialogOpen: false,
            deleteFeatureId: null,
            deleteFeatureName: '',
            // Plan Features
            planFeatures: [],
            plans: [],
            pfDialogOpen: false,
            pfDialogMode: 'create',
            pfDialogId: null,
            pfDialogPlanId: '',
            pfDialogFeatureId: '',
            pfDialogPrice: '',
            deletePfDialogOpen: false,
            deletePfId: null,
            // Plan Periodicity delete
            deletePpDialogOpen: false,
            deletePpId: null,
            deletePpName: '',
            // Plan Periodicity Add/Edit dialog
            ppFormDialogOpen: false,
            ppFormEdit: null,
            periodicities: [],
            billingModes: [],
            allowedBillingModes: [1],
        };

        this.closeNotification = this.closeNotification.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        if (this.state.product && this.state.product.id) {
            this.loadGateways();
            this.loadPlanPeriodicities();
            this.loadFeatures();
            this.loadPlans();
            this.loadPeriodicities();
            this.loadBillingModes();
            this.loadAllowedBillingModes();
        }
    }

    handleTabChange(event, newValue) {
        this.setState({ tabValue: newValue });
    }

    loadGateways() {
        this.setState({ loading: true });
        adminProductService.getProductGateways(this.state.product.id)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, gateways: result.data.data || [] });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                Api.kickoff(err);
            });
    }

    loadPlanPeriodicities() {
        adminProductService.getPlanPeriodicities(null, this.state.product.id)
            .then(result => {
                if (result.data.success) {
                    this.setState({ planPeriodicities: result.data.data || [] });
                }
            })
            .catch(err => {
                Api.kickoff(err);
            });
    }

    loadFeatures() {
        const productId = parseInt(this.state.product.id);
        if (!productId || productId <= 0) return;

        adminApplicationService.getFeaturesByApplicationId(productId)
            .then(result => {
                if (result.data.success) {
                    const features = result.data.data || [];
                    this.setState({ features }, () => {
                        if (features.length > 0) {
                            this.loadPlanFeatures();
                        }
                    });
                }
            })
            .catch(err => {
                Api.kickoff(err);
            });
    }

    loadPlans() {
        adminBillingService.getActivePlans(true)
            .then(result => {
                if (result.data.success) {
                    const raw = result.data.data || [];
                    // Deduplicate by planid to get distinct plans
                    const planMap = {};
                    raw.forEach(pp => {
                        const pId = pp.planid ?? pp.planId ?? pp.PlanId;
                        const pName = pp.planname ?? pp.planName ?? pp.PlanName ?? pp.name ?? '-';
                        if (pId && !planMap[pId]) planMap[pId] = { id: pId, name: pName };
                    });
                    this.setState({ plans: Object.values(planMap) });
                }
            })
            .catch(err => {
                Api.kickoff(err);
            });
    }

    loadPeriodicities() {
        adminBillingService.getPeriodicities()
            .then(result => {
                if (result.data.success) {
                    this.setState({ periodicities: result.data.data || [] });
                }
            })
            .catch(err => Api.kickoff(err));
    }

    loadBillingModes() {
        adminProductService.getBillingModes()
            .then(result => {
                if (result.data.success) {
                    this.setState({ billingModes: result.data.data || [] });
                }
            })
            .catch(err => Api.kickoff(err));
    }

    loadAllowedBillingModes() {
        if (!this.state.product || !this.state.product.id) return;
        adminProductService.getAllowedBillingModes(this.state.product.id)
            .then(result => {
                if (result.data.success) {
                    this.setState({ allowedBillingModes: result.data.data || [1] });
                }
            })
            .catch(err => Api.kickoff(err));
    }

    handleOpenDeletePp = (pp) => {
        const name = `${pp.planname ?? pp.planName ?? ''} - ${pp.periodicityname ?? pp.periodicityName ?? ''}`;
        this.setState({ deletePpDialogOpen: true, deletePpId: pp.id, deletePpName: name });
    }

    handleConfirmDeletePp = () => {
        const intl = this.props.intl;
        this.setState({ loading: true, deletePpDialogOpen: false });
        adminProductService.deletePlanPeriodicity(this.state.deletePpId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, openNotification: true, notificationVariant: 'success', notificationMessage: intl.formatMessage({ id: 'admin.pp.delete.success' }) });
                    this.loadPlanPeriodicities();
                } else {
                    this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: 'process.error' }) });
                }
            })
            .catch(err => {
                this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: err.response?.data?.errors?.[0] ?? intl.formatMessage({ id: 'process.error' }) });
                Api.kickoff(err);
            });
    }

    handleOpenPpFormCreate = () => {
        this.setState({ ppFormDialogOpen: true, ppFormEdit: null });
    }

    handleOpenPpFormEdit = (pp) => {
        this.setState({ loading: true });
        adminProductService.getPlanPeriodicityDetail(pp.id)
            .then(result => {
                if (result.data.success) {
                    const raw = result.data.data;
                    const detail = raw?.detail ?? raw?.Detail ?? raw;
                    this.setState({ ppFormDialogOpen: true, ppFormEdit: detail, loading: false });
                } else {
                    this.setState({ ppFormDialogOpen: true, ppFormEdit: pp, loading: false });
                }
            })
            .catch(() => {
                this.setState({ ppFormDialogOpen: true, ppFormEdit: pp, loading: false });
            });
    }

    handleSavePlanPeriodicity = (data) => {
        const intl = this.props.intl;
        this.setState({ loading: true, ppFormDialogOpen: false });

        // Detecta edit pelo state ppFormEdit (null no create, populado no edit), NÃO pelo
        // data.id — porque o dialog preenche data.id no create com o próximo id da sequence
        // (vem de getNextPlanPeriodicityId pra mostrar no form), o que fazia create virar PUT.
        const isEdit = this.state.ppFormEdit != null;
        const promise = isEdit
            ? adminProductService.updatePlanPeriodicity(data.id, data)
            : adminProductService.createPlanPeriodicity({ ...data, applicationId: this.state.product.id });

        promise
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, openNotification: true, notificationVariant: 'success',
                        notificationMessage: isEdit ? intl.formatMessage({ id: 'admin.pp.edit.success' }) : intl.formatMessage({ id: 'admin.pp.create.success' })
                    });
                    this.loadPlanPeriodicities();
                } else {
                    this.setState({ loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: 'process.error' })
                    });
                }
            })
            .catch(err => {
                this.setState({ loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: intl.formatMessage({ id: 'process.error' })
                });
                Api.kickoff(err);
            });
    }

    loadPlanFeatures() {
        adminApplicationService.getPlanFeatures()
            .then(result => {
                if (result.data.success) {
                    const allPf = result.data.data || [];
                    const featureIds = this.state.features.map(f => f.id);
                    const filtered = allPf.filter(pf => featureIds.includes(pf.featureid ?? pf.featureId));
                    this.setState({ planFeatures: filtered });
                }
            })
            .catch(err => {
                Api.kickoff(err);
            });
    }

    // ========== Ensure Gateway Product ==========
    openSyncDialog(gateway) {
        this.setState({
            syncDialogOpen: true,
            syncGatewayId: gateway.gatewayid ?? gateway.gatewayId,
            syncGatewayName: gateway.gatewayname ?? gateway.gatewayName,
        });
    }

    closeSyncDialog() {
        this.setState({ syncDialogOpen: false, syncGatewayId: null, syncGatewayName: '' });
    }

    handleEnsureGatewayProduct() {
        this.setState({ loading: true, syncDialogOpen: false });
        const intl = this.props.intl;

        adminProductService.ensureGatewayProduct(this.state.product.id, this.state.syncGatewayId)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: "admin.products.sync.success" })
                    });
                    this.loadGateways();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    // ========== Toggle Gateway Active ==========
    handleToggleGateway(gateway) {
        const intl = this.props.intl;
        const active = !(gateway.active ?? false);
        const gatewayId = gateway.gatewayid ?? gateway.gatewayId;

        this.setState({ loading: true });

        adminProductService.toggleApplicationGateway(this.state.product.id, gatewayId, active)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: active
                            ? intl.formatMessage({ id: "admin.products.gateway.activated" })
                            : intl.formatMessage({ id: "admin.products.gateway.deactivated" })
                    });
                    this.loadGateways();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    // ========== Plan Periodicity Detail ==========
    openPpDetailDialog(ppId) {
        this.setState({ loading: true });
        adminProductService.getPlanPeriodicityDetail(ppId)
            .then(result => {
                if (result.data.success) {
                    const data = result.data.data;
                    this.setState({
                        loading: false,
                        ppDetailDialogOpen: true,
                        ppDetail: data.detail,
                        ppGateways: data.gateways || [],
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                Api.kickoff(err);
            });
    }

    closePpDetailDialog() {
        this.setState({ ppDetailDialogOpen: false, ppDetail: null, ppGateways: [] });
    }

    // ========== Ensure Gateway Price ==========
    openPriceDialog(ppId, gateway) {
        this.setState({
            priceDialogOpen: true,
            pricePlanPeriodicityId: ppId,
            priceGatewayId: gateway.gatewayid ?? gateway.gatewayId,
            priceGatewayName: gateway.gatewayname ?? gateway.gatewayName,
            priceValue: '',
        });
    }

    closePriceDialog() {
        this.setState({ priceDialogOpen: false, pricePlanPeriodicityId: null, priceGatewayId: null, priceValue: '' });
    }

    handleEnsureGatewayPrice() {
        const { pricePlanPeriodicityId, priceGatewayId, priceValue } = this.state;
        const intl = this.props.intl;
        const price = parseFloat(priceValue);

        if (!price || price <= 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "admin.products.price.required" })
            });
            return;
        }

        this.setState({ loading: true, priceDialogOpen: false });

        adminProductService.ensureGatewayPrice(pricePlanPeriodicityId, priceGatewayId, price)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: "admin.products.price.sync.success" })
                    });
                    if (this.state.ppDetailDialogOpen) {
                        this.openPpDetailDialog(pricePlanPeriodicityId);
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    // ========== Features CRUD ==========
    handleOpenFeatureDialog(mode, feature = null) {
        if (mode === 'create') {
            adminProductService.getNextFeatureId()
                .then(result => {
                    if (result.data.success) {
                        const nextId = result.data.data?.nextid ?? result.data.data?.NextId ?? result.data.data?.nextId ?? 1;
                        this.setState({
                            featureDialogOpen: true, featureDialogMode: 'create',
                            featureDialogId: null, featureDialogFeatureId: String(nextId),
                            featureDialogName: '', featureDialogDescription: '', featureNextId: nextId,
                        });
                    }
                })
                .catch(() => {
                    this.setState({
                        featureDialogOpen: true, featureDialogMode: 'create',
                        featureDialogId: null, featureDialogFeatureId: '',
                        featureDialogName: '', featureDialogDescription: '',
                    });
                });
        } else {
            this.setState({
                featureDialogOpen: true, featureDialogMode: 'edit',
                featureDialogId: feature.id,
                featureDialogFeatureId: String(feature.id),
                featureDialogName: feature.name ?? '',
                featureDialogDescription: feature.description ?? '',
            });
        }
    }

    handleCloseFeatureDialog() {
        this.setState({ featureDialogOpen: false });
    }

    handleSaveFeature() {
        const { featureDialogMode, featureDialogId, featureDialogFeatureId, featureDialogName, featureDialogDescription } = this.state;
        const intl = this.props.intl;

        if (!featureDialogName || !featureDialogName.trim()) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: intl.formatMessage({ id: "admin.feature.name.required" }) });
            return;
        }

        const featureId = parseInt(featureDialogFeatureId);
        if (featureDialogMode === 'create' && (!featureId || featureId <= 0)) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "ID é obrigatório" });
            return;
        }

        this.setState({ loading: true });

        const promise = featureDialogMode === 'create'
            ? adminProductService.createFeatureDapper({ id: featureId, name: featureDialogName.trim(), description: featureDialogDescription?.trim() || null, applicationId: this.state.product.id })
            : adminProductService.updateFeatureDapper({ id: featureDialogId, name: featureDialogName.trim(), description: featureDialogDescription?.trim() || null });

        promise
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, featureDialogOpen: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: featureDialogMode === 'create' ? "admin.feature.create.success" : "admin.feature.edit.success" })
                    });
                    this.loadFeatures();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    handleDeleteFeature() {
        const { deleteFeatureId } = this.state;
        const intl = this.props.intl;

        this.setState({ loading: true, deleteFeatureDialogOpen: false });

        adminApplicationService.deleteFeature(deleteFeatureId)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: "admin.feature.delete.success" })
                    });
                    this.loadFeatures();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    // ========== Plan Features CRUD ==========
    handleOpenPfDialog(mode, pf = null) {
        this.setState({
            pfDialogOpen: true,
            pfDialogMode: mode,
            pfDialogId: pf ? pf.id : null,
            pfDialogPlanId: pf ? String(pf.planid ?? pf.planId) : '',
            pfDialogFeatureId: pf ? String(pf.featureid ?? pf.featureId) : '',
            pfDialogPrice: pf ? String(pf.featureprice ?? pf.featurePrice) : '',
        });
    }

    handleClosePfDialog() {
        this.setState({ pfDialogOpen: false });
    }

    handleSavePlanFeature() {
        const { pfDialogMode, pfDialogId, pfDialogPlanId, pfDialogFeatureId, pfDialogPrice } = this.state;
        const intl = this.props.intl;

        if (!pfDialogPlanId || !pfDialogFeatureId) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "admin.planfeature.fields.required" })
            });
            return;
        }

        this.setState({ loading: true, pfDialogOpen: false });

        const data = {
            planId: parseInt(pfDialogPlanId),
            featureId: parseInt(pfDialogFeatureId),
            featurePrice: parseFloat(pfDialogPrice) || 0,
        };

        const promise = pfDialogMode === 'create'
            ? adminApplicationService.createPlanFeature(data)
            : adminApplicationService.updatePlanFeature({ ...data, id: pfDialogId });

        promise
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: pfDialogMode === 'create' ? "admin.planfeature.create.success" : "admin.planfeature.edit.success" })
                    });
                    this.loadPlanFeatures();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    handleDeletePlanFeature() {
        const { deletePfId } = this.state;
        const intl = this.props.intl;

        this.setState({ loading: true, deletePfDialogOpen: false });

        adminApplicationService.deletePlanFeature(deletePfId)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "success",
                        notificationMessage: intl.formatMessage({ id: "admin.planfeature.delete.success" })
                    });
                    this.loadPlanFeatures();
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    formatCurrency(value) {
        if (value == null) return '-';
        return `R$ ${Number(value).toFixed(2)}`;
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;
        const { product, tabValue, gateways, planPeriodicities, ppDetail, ppGateways, features, planFeatures, plans } = this.state;

        const thStyle = {
            backgroundColor: '#f5f5f5', fontWeight: 700, fontSize: '0.8rem', color: '#424242',
            textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '2px solid #9e9e9e',
            padding: '12px 16px', whiteSpace: 'nowrap'
        };

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container className={classes.mb20} spacing={0}>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<ArrowBackIcon />}
                                    onClick={() => this.props.history.push(`/${this.props.match.params.lang}/admin-products`)}
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                >
                                    {intl.formatMessage({ id: "back" })}
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <SectionCard
                                    context="info"
                                    title={
                                        <span>
                                            {product.name || intl.formatMessage({ id: "admin.products.detail" })}
                                            {(product.isproduct ?? product.isProduct) && (
                                                <Chip label={intl.formatMessage({ id: "admin.products.is.product" })} color="primary" size="small" style={{ marginLeft: 10 }} />
                                            )}
                                        </span>
                                    }
                                    subtitle={`ID: ${product.id}`}
                                    divider={false}
                                />
                            </Grid>
                        </Grid>

                        <Paper style={{ marginTop: 16 }}>
                            <Tabs
                                value={tabValue}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                            >
                                <Tab label={intl.formatMessage({ id: "admin.products.tab.gateways" })} />
                                <Tab label={intl.formatMessage({ id: "admin.products.tab.plan.periodicities" })} />
                                <Tab label={intl.formatMessage({ id: "admin.products.tab.features" })} />
                            </Tabs>

                            {/* Tab 0: Gateways */}
                            <TabPanel value={tabValue} index={0}>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow style={thStyle}>
                                                <TableCell>{intl.formatMessage({ id: "admin.products.gateway.name" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.products.gateway.product.id" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "status" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "actions" })}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {gateways.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center">
                                                        {intl.formatMessage({ id: "admin.products.no.gateways" })}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            {gateways.map((gw, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{gw.gatewayname ?? gw.gatewayName}</TableCell>
                                                    <TableCell>
                                                        {(gw.gatewayproductid ?? gw.gatewayProductId) || <span style={{ color: '#999' }}>-</span>}
                                                    </TableCell>
                                                    <TableCell>
                                                        {gw.active
                                                            ? <Chip label="Active" size="small" style={{ backgroundColor: '#4caf50', color: '#fff' }} />
                                                            : <Chip label="Inactive" size="small" />
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        <Tooltip title={gw.active
                                                            ? intl.formatMessage({ id: "admin.products.deactivate.gateway" })
                                                            : intl.formatMessage({ id: "admin.products.activate.gateway" })
                                                        }>
                                                            <Switch
                                                                checked={!!gw.active}
                                                                onChange={() => {
                                                                    if (gw.active) {
                                                                        this.handleToggleGateway(gw);
                                                                    } else {
                                                                        this.openSyncDialog(gw);
                                                                    }
                                                                }}
                                                                color="primary"
                                                                size="small"
                                                            />
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>

                            {/* Tab 1: Plan Periodicities */}
                            <TabPanel value={tabValue} index={1}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                                    <Button variant="contained" size="small" style={{ backgroundColor: '#8BC34A', color: '#fff' }}
                                        onClick={this.handleOpenPpFormCreate}>
                                        {intl.formatMessage({ id: "admin.pp.add.button" })}
                                    </Button>
                                </div>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow style={thStyle}>
                                                <TableCell>ID</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.products.pp.plan" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.products.pp.periodicity" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.products.pp.value.month" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.products.pp.value" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.subscription.agents" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.subscription.attendances" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.pp.billing.mode" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "actions" })}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {planPeriodicities.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={9} align="center">
                                                        {intl.formatMessage({ id: "admin.products.no.plan.periodicities" })}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            {planPeriodicities.map((pp, idx) => (
                                                <TableRow key={idx} hover style={{ cursor: 'pointer' }}
                                                    onClick={() => this.handleOpenPpFormEdit(pp)}>
                                                    <TableCell>{pp.id}</TableCell>
                                                    <TableCell>{pp.planname ?? pp.planName}</TableCell>
                                                    <TableCell>{pp.periodicityname ?? pp.periodicityName}</TableCell>
                                                    <TableCell>{this.formatCurrency(pp.planvaluepermonth ?? pp.planValuePerMonth)}</TableCell>
                                                    <TableCell>{this.formatCurrency(pp.planvalue ?? pp.planValue)}</TableCell>
                                                    <TableCell>{(pp.agentlimitquantity ?? pp.agentLimitQuantity) || '-'}</TableCell>
                                                    <TableCell>{(pp.attendancelimitpermonth ?? pp.attendanceLimitPerMonth) || '-'}</TableCell>
                                                    <TableCell>{(pp.billingmode ?? pp.billingMode ?? 'unit')}</TableCell>
                                                    <TableCell>
                                                        <Tooltip title={intl.formatMessage({ id: "admin.products.pp.detail" })}>
                                                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.openPpDetailDialog(pp.id); }}>
                                                                <VisibilityIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={intl.formatMessage({ id: "delete" })}>
                                                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.handleOpenDeletePp(pp); }} style={{ color: '#f44336' }}>
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>

                            {/* Tab 2: Features */}
                            <TabPanel value={tabValue} index={2}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                    <Typography variant="h6">
                                        {intl.formatMessage({ id: "admin.products.tab.features" })}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<AddIcon />}
                                        onClick={() => this.handleOpenFeatureDialog('create')}
                                    >
                                        {intl.formatMessage({ id: "admin.feature.new" })}
                                    </Button>
                                </div>

                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow style={thStyle}>
                                                <TableCell>ID</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "name" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.feature.user.limit" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.feature.most.chosed" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "actions" })}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {features.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center">
                                                        {intl.formatMessage({ id: "admin.feature.empty" })}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            {features.map((feat, idx) => {
                                                const userLimit = feat.userlimit ?? feat.userLimit
                                                const mostChosed = feat.mostchosed ?? feat.mostChosed
                                                return (
                                                <TableRow key={idx}>
                                                    <TableCell>{feat.id}</TableCell>
                                                    <TableCell>{feat.name}</TableCell>
                                                    <TableCell>{userLimit != null ? userLimit : '-'}</TableCell>
                                                    <TableCell>
                                                        {mostChosed
                                                            ? <CheckCircleIcon style={{ color: '#4caf50' }} />
                                                            : <CancelIcon style={{ color: '#9e9e9e' }} />
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        <Tooltip title={intl.formatMessage({ id: "edit" })}>
                                                            <IconButton size="small" onClick={() => this.handleOpenFeatureDialog('edit', feat)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={intl.formatMessage({ id: "delete" })}>
                                                            <IconButton size="small" onClick={() => this.setState({ deleteFeatureDialogOpen: true, deleteFeatureId: feat.id, deleteFeatureName: feat.name })}>
                                                                <DeleteIcon style={{ color: '#f44336' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {/* Plan Features Section */}
                                {features.length > 0 && (
                                    <div style={{ marginTop: 32 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                            <Typography variant="h6">
                                                {intl.formatMessage({ id: "admin.planfeature.title" })}
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                startIcon={<AddIcon />}
                                                onClick={() => { this.loadPlanFeatures(); this.handleOpenPfDialog('create'); }}
                                            >
                                                {intl.formatMessage({ id: "admin.planfeature.new" })}
                                            </Button>
                                        </div>

                                        <TableContainer>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow style={thStyle}>
                                                        <TableCell>ID</TableCell>
                                                        <TableCell>{intl.formatMessage({ id: "admin.products.pp.plan" })}</TableCell>
                                                        <TableCell>{intl.formatMessage({ id: "admin.products.tab.features" })}</TableCell>
                                                        <TableCell>{intl.formatMessage({ id: "admin.planfeature.price" })}</TableCell>
                                                        <TableCell>{intl.formatMessage({ id: "actions" })}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {planFeatures.length === 0 && (
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="center">
                                                                {intl.formatMessage({ id: "admin.planfeature.empty" })}
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    {planFeatures.map((pf, idx) => (
                                                        <TableRow key={idx}>
                                                            <TableCell>{pf.id}</TableCell>
                                                            <TableCell>{pf.plan ? pf.plan.name : (pf.planid ?? pf.planId)}</TableCell>
                                                            <TableCell>{pf.feature ? pf.feature.name : (pf.featureid ?? pf.featureId)}</TableCell>
                                                            <TableCell>{this.formatCurrency(pf.featureprice ?? pf.featurePrice)}</TableCell>
                                                            <TableCell>
                                                                <Tooltip title={intl.formatMessage({ id: "edit" })}>
                                                                    <IconButton size="small" onClick={() => this.handleOpenPfDialog('edit', pf)}>
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title={intl.formatMessage({ id: "delete" })}>
                                                                    <IconButton size="small" onClick={() => this.setState({ deletePfDialogOpen: true, deletePfId: pf.id })}>
                                                                        <DeleteIcon style={{ color: '#f44336' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </TabPanel>
                        </Paper>

                        {/* Dialog: Ensure Gateway Product */}
                        <Dialog open={this.state.syncDialogOpen} onClose={() => this.closeSyncDialog()} maxWidth="sm" fullWidth>
                            <DialogTitle>{intl.formatMessage({ id: "admin.products.sync.gateway" })}</DialogTitle>
                            <DialogContent>
                                <Typography>
                                    {intl.formatMessage({ id: "admin.products.sync.confirm" }, {
                                        product: product.name,
                                        gateway: this.state.syncGatewayName
                                    })}
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.closeSyncDialog()} color="default">
                                    {intl.formatMessage({ id: "cancel" })}
                                </Button>
                                <Button onClick={() => this.handleEnsureGatewayProduct()} color="primary" variant="contained">
                                    {intl.formatMessage({ id: "confirm" })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Dialog: Plan Periodicity Detail with Gateways */}
                        <Dialog open={this.state.ppDetailDialogOpen} onClose={() => this.closePpDetailDialog()} maxWidth="md" fullWidth>
                            <DialogTitle>{intl.formatMessage({ id: "admin.products.pp.detail" })}</DialogTitle>
                            <DialogContent>
                                {ppDetail && (
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.products.pp.plan" })}</Typography>
                                            <Typography>{ppDetail.planname ?? ppDetail.planName}</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.products.pp.periodicity" })}</Typography>
                                            <Typography>{ppDetail.periodicityname ?? ppDetail.periodicityName}</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.products.pp.application" })}</Typography>
                                            <Typography>{ppDetail.applicationname ?? ppDetail.applicationName ?? '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.products.pp.value.month" })}</Typography>
                                            <Typography>{this.formatCurrency(ppDetail.planvaluepermonth ?? ppDetail.planValuePerMonth)}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.products.pp.value" })}</Typography>
                                            <Typography>{this.formatCurrency(ppDetail.planvalue ?? ppDetail.planValue)}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.subscription.agents" })}</Typography>
                                            <Typography>{(ppDetail.agentlimitquantity ?? ppDetail.agentLimitQuantity) || '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.subscription.disk" })}</Typography>
                                            <Typography>{(ppDetail.disklimitusage ?? ppDetail.diskLimitUsage) || '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.subscription.attendances" })}</Typography>
                                            <Typography>{(ppDetail.attendancelimitpermonth ?? ppDetail.attendanceLimitPerMonth) || '-'}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.products.pp.additional.agent" })}</Typography>
                                            <Typography>{this.formatCurrency(ppDetail.additionalvalueagent ?? ppDetail.additionalValueAgent)}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.products.pp.attendance.value" })}</Typography>
                                            <Typography>{this.formatCurrency(ppDetail.attendancevalue ?? ppDetail.attendanceValue)}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.pp.disk.overage.value" })}</Typography>
                                            <Typography>{this.formatCurrency(ppDetail.diskoveragevalue ?? ppDetail.diskOverageValue)}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.pp.billing.mode" })}</Typography>
                                            <Typography style={{ fontWeight: 600 }}>{(ppDetail.billingmode ?? ppDetail.billingMode ?? 'unit').toUpperCase()}</Typography>
                                        </Grid>
                                        {(ppDetail.billingmode ?? ppDetail.billingMode) === 'credit' && (
                                            <>
                                                <Grid item xs={3}>
                                                    <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.pp.credit.monthly" })}</Typography>
                                                    <Typography>{this.formatCurrency(ppDetail.creditamountmonthly ?? ppDetail.creditAmountMonthly)}</Typography>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.pp.credit.alert" })}</Typography>
                                                    <Typography>{this.formatCurrency(ppDetail.creditalertthreshold ?? ppDetail.creditAlertThreshold)}</Typography>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.pp.credit.auto.recharge" })}</Typography>
                                                    <Typography>{(ppDetail.creditautorechargeenabled ?? ppDetail.creditAutoRechargeEnabled) ? 'Sim' : 'Não'}</Typography>
                                                </Grid>
                                                {(ppDetail.creditautorechargeenabled ?? ppDetail.creditAutoRechargeEnabled) && (
                                                    <>
                                                        <Grid item xs={3}>
                                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.pp.credit.recharge.amount" })}</Typography>
                                                            <Typography>{this.formatCurrency(ppDetail.creditautorechargeamount ?? ppDetail.creditAutoRechargeAmount)}</Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: "admin.pp.credit.recharge.trigger" })}</Typography>
                                                            <Typography>{this.formatCurrency(ppDetail.creditautorechargetrigger ?? ppDetail.creditAutoRechargeTrigger)}</Typography>
                                                        </Grid>
                                                    </>
                                                )}
                                            </>
                                        )}

                                        <Grid item xs={12} style={{ marginTop: 16 }}>
                                            <Typography variant="h6">{intl.formatMessage({ id: "admin.products.tab.gateways" })}</Typography>
                                            <TableContainer component={Paper} style={{ marginTop: 8 }}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow style={thStyle}>
                                                            <TableCell>{intl.formatMessage({ id: "admin.products.gateway.name" })}</TableCell>
                                                            <TableCell>{intl.formatMessage({ id: "admin.products.gateway.price.id" })}</TableCell>
                                                            <TableCell>{intl.formatMessage({ id: "admin.products.gateway.currency" })}</TableCell>
                                                            <TableCell>{intl.formatMessage({ id: "status" })}</TableCell>
                                                            <TableCell>{intl.formatMessage({ id: "actions" })}</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {ppGateways.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={5} align="center">
                                                                    {intl.formatMessage({ id: "admin.products.no.gateways" })}
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                        {ppGateways.map((gw, idx) => (
                                                            <TableRow key={idx}>
                                                                <TableCell>{gw.gatewayname ?? gw.gatewayName}</TableCell>
                                                                <TableCell>{(gw.gatewaypriceid ?? gw.gatewayPriceId) || <span style={{ color: '#999' }}>-</span>}</TableCell>
                                                                <TableCell>{gw.currency || '-'}</TableCell>
                                                                <TableCell>
                                                                    {gw.active
                                                                        ? <Chip label="Active" size="small" style={{ backgroundColor: '#4caf50', color: '#fff' }} />
                                                                        : <Chip label="Inactive" size="small" />
                                                                    }
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Tooltip title={intl.formatMessage({ id: "admin.products.sync.price" })}>
                                                                        <IconButton size="small" onClick={() => this.openPriceDialog(ppDetail.id, gw)}>
                                                                            <SyncIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.closePpDetailDialog()} color="default">
                                    {intl.formatMessage({ id: "close" })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Dialog: Ensure Gateway Price */}
                        <Dialog open={this.state.priceDialogOpen} onClose={() => this.closePriceDialog()} maxWidth="sm" fullWidth>
                            <DialogTitle>{intl.formatMessage({ id: "admin.products.sync.price" })}</DialogTitle>
                            <DialogContent>
                                <Typography style={{ marginBottom: 16 }}>
                                    {intl.formatMessage({ id: "admin.products.price.confirm" }, {
                                        gateway: this.state.priceGatewayName
                                    })}
                                </Typography>
                                <TextField
                                    label={intl.formatMessage({ id: "admin.products.price.label" })}
                                    type="number"
                                    value={this.state.priceValue}
                                    onChange={(e) => this.setState({ priceValue: e.target.value })}
                                    fullWidth
                                    variant="outlined"
                                    inputProps={{ min: 0, step: 0.01 }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.closePriceDialog()} color="default">
                                    {intl.formatMessage({ id: "cancel" })}
                                </Button>
                                <Button onClick={() => this.handleEnsureGatewayPrice()} color="primary" variant="contained">
                                    {intl.formatMessage({ id: "confirm" })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Dialog: Feature Create/Edit */}
                        <Dialog open={this.state.featureDialogOpen} onClose={() => this.handleCloseFeatureDialog()} maxWidth="sm" fullWidth>
                            <DialogTitle style={{ backgroundColor: '#8BC34A', color: '#fff' }}>
                                {intl.formatMessage({ id: this.state.featureDialogMode === 'create' ? "admin.feature.new" : "admin.feature.edit" })}
                            </DialogTitle>
                            <DialogContent style={{ paddingTop: 20 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="ID"
                                            type="number"
                                            value={this.state.featureDialogFeatureId}
                                            onChange={(e) => this.setState({ featureDialogFeatureId: e.target.value })}
                                            fullWidth variant="outlined" size="small"
                                            disabled={this.state.featureDialogMode === 'edit'}
                                            inputProps={{ min: '1' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <TextField
                                            label={intl.formatMessage({ id: "name" })}
                                            value={this.state.featureDialogName}
                                            onChange={(e) => this.setState({ featureDialogName: e.target.value })}
                                            fullWidth variant="outlined" size="small"
                                            autoFocus
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.feature.description" })}
                                            value={this.state.featureDialogDescription}
                                            onChange={(e) => this.setState({ featureDialogDescription: e.target.value })}
                                            fullWidth variant="outlined"
                                            multiline minRows={3} maxRows={5}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.handleCloseFeatureDialog()} color="default">
                                    {intl.formatMessage({ id: "cancel" })}
                                </Button>
                                <Button onClick={() => this.handleSaveFeature()} variant="contained" style={{ backgroundColor: '#8BC34A', color: '#fff' }}>
                                    {intl.formatMessage({ id: "save" })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Delete Feature Confirmation */}
                        <ConfirmActionDialog
                            title={intl.formatMessage({ id: "admin.feature.delete" })}
                            message={intl.formatMessage({ id: "admin.feature.delete.confirm" }, { name: this.state.deleteFeatureName })}
                            open={this.state.deleteFeatureDialogOpen}
                            onConfirm={() => this.handleDeleteFeature()}
                            onClose={() => this.setState({ deleteFeatureDialogOpen: false })}
                        />

                        {/* Delete Plan Periodicity Confirmation */}
                        <ConfirmActionDialog
                            title={intl.formatMessage({ id: "admin.pp.delete.title" })}
                            message={intl.formatMessage({ id: "admin.pp.delete.confirm" }, { name: this.state.deletePpName })}
                            open={this.state.deletePpDialogOpen}
                            onConfirm={() => this.handleConfirmDeletePp()}
                            onClose={() => this.setState({ deletePpDialogOpen: false })}
                        />

                        {/* Dialog: Plan Feature Create/Edit */}
                        <Dialog open={this.state.pfDialogOpen} onClose={() => this.handleClosePfDialog()} maxWidth="sm" fullWidth>
                            <DialogTitle>
                                {intl.formatMessage({ id: this.state.pfDialogMode === 'create' ? "admin.planfeature.new" : "admin.planfeature.edit" })}
                            </DialogTitle>
                            <DialogContent>
                                <TextField
                                    label={intl.formatMessage({ id: "admin.products.pp.plan" })}
                                    select
                                    value={this.state.pfDialogPlanId}
                                    onChange={(e) => this.setState({ pfDialogPlanId: e.target.value })}
                                    fullWidth
                                    variant="outlined"
                                    style={{ marginBottom: 16 }}
                                    SelectProps={{ native: true }}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    <option value=""></option>
                                    {plans.map(p => (
                                        <option key={p.id} value={p.id}>{p.name}</option>
                                    ))}
                                </TextField>
                                <TextField
                                    label={intl.formatMessage({ id: "admin.products.tab.features" })}
                                    select
                                    value={this.state.pfDialogFeatureId}
                                    onChange={(e) => this.setState({ pfDialogFeatureId: e.target.value })}
                                    fullWidth
                                    variant="outlined"
                                    style={{ marginBottom: 16 }}
                                    SelectProps={{ native: true }}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    <option value=""></option>
                                    {features.map(f => (
                                        <option key={f.id} value={f.id}>{f.name}</option>
                                    ))}
                                </TextField>
                                <TextField
                                    label={intl.formatMessage({ id: "admin.planfeature.price" })}
                                    type="number"
                                    value={this.state.pfDialogPrice}
                                    onChange={(e) => this.setState({ pfDialogPrice: e.target.value })}
                                    fullWidth
                                    variant="outlined"
                                    inputProps={{ min: 0, step: 0.01 }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.handleClosePfDialog()} color="default">
                                    {intl.formatMessage({ id: "cancel" })}
                                </Button>
                                <Button onClick={() => this.handleSavePlanFeature()} color="primary" variant="contained">
                                    {intl.formatMessage({ id: "save" })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Delete Plan Feature Confirmation */}
                        <ConfirmActionDialog
                            title={intl.formatMessage({ id: "admin.planfeature.delete" })}
                            message={intl.formatMessage({ id: "admin.planfeature.delete.confirm" })}
                            open={this.state.deletePfDialogOpen}
                            onConfirm={() => this.handleDeletePlanFeature()}
                            onClose={() => this.setState({ deletePfDialogOpen: false })}
                        />

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <PlanPeriodicityDialog
                            open={this.state.ppFormDialogOpen}
                            onClose={() => this.setState({ ppFormDialogOpen: false })}
                            onSave={this.handleSavePlanPeriodicity}
                            planPeriodicity={this.state.ppFormEdit}
                            applicationId={this.state.product ? this.state.product.id : 0}
                            applicationName={this.state.product ? this.state.product.name : ''}
                            plans={this.state.plans}
                            periodicities={this.state.periodicities}
                            allowedBillingModes={this.state.allowedBillingModes}
                            billingModes={this.state.billingModes}
                            intl={this.props.intl}
                        />
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminProductDetail.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminProductDetail)));
